/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/motion-background.jpg";

const imageAltText = "purple and blue abstract background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "Full Stack Developer with hands-on experience building scalable web applications using Java, Spring Boot, and modern frontend frameworks like React and Angular. I enjoy turning complex problems into simple, elegant solutions.";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Java",
  "Spring Boot",
  "React",
  "Angular",
  "REST APIs",
  "JWT",
  "Docker",
  "PostgreSQL",
  "Git",
  "CI/CD",
  "Python",
  "RPA (UiPath)",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I believe in writing clean, maintainable code and continuously learning new technologies. My goal is to contribute to impactful projects while growing as a full-stack engineer.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div className="content-panel about-panel">
        <p className="eyebrow">A little context</p>
        <h2>About me</h2>
        <p className="large">{description}</p>
        <hr />
        <ul
          className="skills-list"
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p className="about-detail">{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
